import React from 'react';
export function AnnouncementBar() {
  return <aside className="w-full bg-brand-navy px-4 py-2.5 text-center text-white" data-id="element-24" data-mp="2tgqpao3xs0lk">
      <p className="mx-auto max-w-4xl text-[11px] font-medium leading-snug tracking-wide sm:text-xs" data-id="element-25" data-mp="olbw9uqst6dw">
        <span aria-hidden="true" data-id="element-26" data-mp="jsit3baza63x">🎉</span> Precio de lanzamiento disponible por
        tiempo limitado{' '}
        <span className="px-1 text-brand-gold" aria-hidden="true" data-id="element-27" data-mp="euqopht5criu">
          ·
        </span>{' '}
        Descarga inmediata <span aria-hidden="true" data-id="element-28" data-mp="9tkutgnr2y7q">✅</span>
      </p>
    </aside>;
}